module.exports = __webpack_public_path__ + "media/bootstrap-icons/app-indicator-b104a90d.svg";